module.exports = __webpack_public_path__ + "img/achievement3.67f65b4c.jpg";